export interface GetPlansResponse {
  status: string;
  msg: string;
  error: boolean;
  errors: any;
  page: number;
  nextPage: number | null;
  lastPage: number;
  nextPageUrl: string | null;
  data: {
    content: Plan[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
    numberOfElements: number;
    first: boolean;
    last: boolean;
    empty: boolean;
    pageable: any;
    sort: any[];
    flow?: 'MOVEL' | 'BOLETO_CARTAO';
  };
}

// Resposta para detalhe de plano (data é um objeto único)
export interface GetPlanDetailResponse {
  status: string;
  msg: string;
  error: boolean;
  errors: any;
  page: any;
  nextPage: any;
  lastPage: any;
  nextPageUrl: any;
  data: Plan;
}

export interface Plan {
  id?: string | number | null;
  uuid: string;
  name: string;
  description: string;
  price: number;
  priceMonthly: number | null;
  duration: any;
  includedFeatures: any;
  maxUsersDevices: any;
  validFrom: any;
  validUntil: any;
  status: string;
  planCode: string;
  additionalDetails: any;
  user: PlanUser;
  payments: any[];
  planTerms: any[];
  termsUrl: any;
  urlLinks: any[];
  productUuid: string;
  billingModel: string;
  billingFrequency: string;
  billingCycle: string;
  lastRenew: any;
  orderUuid?: string;
  ordersUuid?: string;
  variation: boolean;
  allowedCancellation?: boolean;
  bundle?: boolean;
  origin?: any;
  creationOrigin?: any;
  creationDate?: any;
  orderItemId?: any;
  productName: string;
  variationName: string;
  expirationDate?: any;
  hasFidelity: boolean;
  lastFourDigits?: any;
  cardFlag?: any;
  quantity?: number | null;
  imageUrl?: string | null;
  cardToken?: string;
  flow?: 'MOVEL' | 'BOLETO_CARTAO';
  parentProduct?: any;
}

export interface PlanUser {
  uuid: string;
  firstName: string;
  lastName: string;
  displayName: string;
  email: string;
  login: string;
  createdAt: string;
  creationDate: string;
  document: string;
  documentType: string;
  role: string;
  business: any;
  phone: string;
  addresses: PlanUserAddress[];
  ordersPuchasedQuantity: any;
  userToken: any;
  // Alguns ambientes podem retornar a chave corretamente escrita
  ordersPurchasedQuantity?: any;
  terms?: any[];
}

export interface PlanUserAddress {
  uuid: string;
  address: string;
  neighborhood: string;
  city: string;
  state: string;
  country: string;
  zipCode: string;
  complement: string;
  main: boolean;
  type: string;
  number: string;
}

export interface PlanCancellationResponse {
  error: boolean;
  msg: string;
  data: PlanCancellationData;
}

export interface PlanCancellationData {
  protocolId: string;
  transactionId: string;
  effectiveExpirationDate: string;
  canceldDate: string;
}

export interface PlanChangeRequest {
  planUuid: string;
  msisdn: string[];
}

export interface PlanChangeQntRequest {
  quantity: string;
  msisdn?: string[];
}

export interface PlanHistoryEntry {
  uuid: string;
  dateTime: string;
  productName: string;
  quantity: number;
  action: 'purchase' | 'cancellation' | 'licenseChange' | 'quantityChange';
}

export interface PlanHistoryResponse {
  error: boolean;
  msg: string;
  data: PlanHistoryEntry[];
}
